module.exports = __webpack_public_path__ + "img/geek-market-logo.fc781119.svg";